import { useMemo } from 'react';
import { IdPs } from '../constants/providers';
import providersService from '../services/providers';
import { AppConfig } from '../types/app';
import { IdProvider } from '../types/auth';

export function useFilteredProviders(
  config: AppConfig,
  providers: IdProvider[]
) {
  const clientID = providersService.getClientId();

  const filteredProviders = useMemo(() => {
    const idPsToHide = config.clients[clientID]
      ? config.clients[clientID].idPsToHide
      : [];

    const bidProvider = !idPsToHide?.includes(IdPs.AWSBuilderID)
      ? providers.find((p) => p.idp === IdPs.AWSBuilderID)
      : undefined;

    const lwaProvider = !idPsToHide?.includes(IdPs.LoginWithAmazon)
      ? providers.find((p) => p.idp === IdPs.LoginWithAmazon)
      : undefined;

    const apnProvider = !idPsToHide?.includes(IdPs.AWSPartnerNetwork)
      ? providers.find((p) => p.idp === IdPs.AWSPartnerNetwork)
      : undefined;

    const amazonFederateProvider = providers.find(
      (p) => p.idp === IdPs.AmazonFederate
    );

    const visibleProviders = providers
      .filter(providersService.isVisibleProvider)
      .filter((p) => !idPsToHide?.includes(p.idp))
      .filter((p) => p.idp !== IdPs.AWSBuilderID) // AWS Builder ID is handled separately
      .filter((p) => p.idp !== IdPs.LoginWithAmazon) // LWA is handled separately
      .filter((p) => p.idp !== IdPs.AWSPartnerNetwork) // APN is handled separately
      .filter((p) => p.idp !== IdPs.AmazonFederate); // AmazonFederate is handled separately

    const providerRequireSeperator = providers
      .filter((p) => p.idp !== IdPs.AWSBuilderID)
      .filter(providersService.isVisibleProvider);

    return {
      bidProvider,
      lwaProvider,
      apnProvider,
      amazonFederateProvider,
      visibleProviders,
      providerRequireSeperator,
    };
  }, [providers, config, clientID]);

  return filteredProviders;
}
